import { useEffect, useState } from "react";
import api from "@/lib/api";
import { setBrandCache } from "@/lib/branding";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Building2 } from "lucide-react";

const FIELDS = [
    ["company_name", "Company name (shown to customers)", "Summit Valley Waste"],
    ["support_email", "Support email", "support@yourcompany.com"],
    ["support_phone", "Support phone", "(555) 010-2020"],
    ["website", "Website", "https://yourcompany.com"],
    ["logo_url", "Logo image URL (optional)", "https://…/logo.png"],
];

/** Per-client white-label settings: WasteHQ stays the app name, this is the hauler's identity. */
export function BrandingCard() {
    const [form, setForm] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => { api.get("/branding").then(({ data }) => setForm(data)); }, []);
    if (!form) return null;

    const save = async () => {
        setBusy(true);
        try {
            const { data } = await api.put("/branding", Object.fromEntries(FIELDS.map(([k]) => [k, form[k] || ""])));
            setBrandCache(data);
            setForm(data);
            toast.success("Branding saved");
        } catch (e) {
            toast.error(e.response?.data?.detail || "Save failed");
        } finally { setBusy(false); }
    };

    return (
        <Card className="lg:col-span-2" data-testid="branding-card">
            <CardContent className="p-6 space-y-4">
                <div className="flex items-center gap-2">
                    <Building2 className="w-5 h-5 text-primary" />
                    <div>
                        <div className="font-heading font-semibold">Company branding</div>
                        <div className="text-xs text-muted-foreground">
                            Staff screens say WasteHQ. Invoices, the customer portal, signup form and customer emails use these details.
                        </div>
                    </div>
                </div>
                <div className="grid sm:grid-cols-2 gap-3">
                    {FIELDS.map(([k, label, ph]) => (
                        <div key={k} className="space-y-1">
                            <Label className="text-xs">{label}</Label>
                            <Input value={form[k] || ""} placeholder={ph} data-testid={`branding-${k}`}
                                   onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} />
                        </div>
                    ))}
                </div>
                <div className="flex justify-end">
                    <Button size="sm" onClick={save} disabled={busy} data-testid="branding-save-btn">
                        {busy ? "Saving…" : "Save branding"}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
}
